import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Grid from 'material-ui/Grid';
// import Hidden from 'material-ui/Hidden';
import { MuiThemeProvider } from 'material-ui/styles';
// import Reboot from 'material-ui/Reboot';
import theme from 'theme';
// import PrivateRoute from 'components/PrivateRoute';
import Header from 'components/Header';
import ModalRouter  from 'routes/Modal';
import Checkout     from 'routes/Checkout';
import Orders       from 'routes/Orders';
// import SideNav from 'components/SideNav';
// import MagicLinkLogin from 'components/MagicLinkLogin';

//FURTHER ROUTES:
// import Landing      from 'routes/Landing';
// import Dashboard    from 'routes/User/Dashboard';
// import Profile      from 'routes/User/Profile';
// import Addresses    from 'routes/User/Addresses';
// import OrderHistory from 'routes/User/OrderHistory';
// import Order        from 'routes/User/Order';
// import Product      from 'routes/Products/Product';
// import ProductsList from 'routes/Products/List';
// import theme from 'theme';


//NOTE: Side Nav disabled 

const App = () => (
  <MuiThemeProvider theme={theme}>
    <main>
      <Grid container>
        <Grid item md={12} style={{ width: '100%', minWidth: '375px'}}>
          <Switch>
            <Route exact path="/checkout/404" component={() => <div>404 Offer Not Found</div>}/>
            <Route path="/checkout/" component={Checkout} />
            <Route path="/orders/" component={Orders} />
          </Switch>
          <ModalRouter />
        </Grid>
      </Grid>
    </main>
  </MuiThemeProvider>
);

export default App;


// WEBPACK FOOTER //
// ./containers/App/index.jsx